import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

import { campaignPath, legacyCampaignTarget } from './prospectingPaths';

/** Ancienne adresse du module (`/boites`, `/import`) : même page sous `/reglages`, requête conservée. */
export function RedirectKeepingQuery({ to }: { to: string }) {
    const { search } = useLocation();
    return <Navigate replace to={`${to}${search}`} />;
}

/**
 * `/campagnes/:id` et l'ancien `/campagnes/:id?onglet=x` : l'onglet passe dans le chemin
 * (Vue d'ensemble par défaut ; Périodes et Paramètres vers les Réglages, à leur ancre),
 * les autres paramètres (`q` des Cibles) suivent.
 */
export function LegacyCampaignTabRedirect() {
    const campaignId = Number(useParams().campaignId);
    const [search] = useSearchParams();
    const { tab, anchor } = legacyCampaignTarget(search.get('onglet'));
    const rest = new URLSearchParams(search);
    rest.delete('onglet');
    const query = rest.toString();

    return <Navigate replace to={{ pathname: campaignPath(campaignId, tab), search: query ? `?${query}` : '', hash: anchor ? `#${anchor}` : '' }} />;
}
